const myText = `
    <style>
    .my-custom-body {
        font-family: 'AkzidenzGroteskStd-Light';
        font-size: 12pt;
        letter-spacing: 0.75pt;
        line-height: 1.4;
        padding: 50px;
    }
    .my-custom-body p{
        font-family: 'AkzidenzGroteskStd-Light';
        font-size: 12pt;
        text-align:left;
    }

    .my-custom-body header {
        font-family: 'AkzidenzGroteskStd-Md';
        font-size: 25pt;
        letter-spacing: 0.5pt;
        line-height: 1;

    }
    .my-custom-body sub {
        font-family: 'AkzidenzGroteskStd-Md';
        font-size: 15pt;
        letter-spacing: 0.5pt;
        line-height: 1.1;

    }
    .my-custom-body small {
        font-family: 'AkzidenzGroteskStd-Light';
        font-size: 9pt;
        letter-spacing: 0.75pt;
        line-height: 1;
    }
  </style>
    <div class="my-custom-body">
        <header>Medical Disclaimer</header>
        <p><small>Valid from December 21, 2018</small><br></p>
        <br>
        <hr>
        <br>
        <sub>Healo is designed to help you achieve pain relief through self-care of musculoskeletal disorders.</sub><br>
        <br><sub>Healo is not a substitute for professional medical advice.</sub><br>
        <br>
        <hr>
        <br>
        <sub>1 &nbsp;&nbsp;Healo</sub><br>
        <br>Healo is a CE certified application for pain relief self-care (the &ldquo;App&rdquo;) provided by Empowered Applications AB, company registration nr. 559093&ndash;0722, in Sweden.<br>
        <br>All content in the App, including text, images, audio, or other formats, is created for informational purposes only. Please note that information presented in the App does not provide you with advice on medical issues.<br>
        <br>By proceeding and using the App, you acknowledge and agree to this legal disclaimer, as amended from time to time.<br>
        <br>
        <br>
        <sub>2 &nbsp;&nbsp;Medical Information</sub><br>
        <br>The App provides selected information about self-care exercise programmes and individualised therapy support. The exercise programmes and therapy support are generated automatically, based on your Self-diagnosis. The exercises and therapy support are not manually tailored to you by a medical professional and may not be appropriate to your specific circumstances. Only healthcare professionals can determine if a self-care exercise programme in the App is appropriate for you.<br>
        <br>If you have, or think you have, any health problems or injuries that might be impaired or aggravated by the exercises in Healo, you should consult healthcare professionals before acting on recommendations by the App. Never disregard professional medical advice or delay in seeking help because of information delivered by the App. You are responsible for ensuring that you do the exercises safely and in accordance with the instructions provided to you by the App.<br>
        <br><br>
        <sub>3 &nbsp;&nbsp;Disclaimer</sub><br>
        <br>All information and material related to the App is provided 'as is' and subject to change without notice. To the extent permitted by applicable law, Empowered Applications makes no representation or warranty whatsoever regarding the completeness, accuracy, 'up-to-dateness', adequacy, suitability, functionality, availability, or operation of the App and the information or materials it contains. By using the App, you accept the risk that the information and materials in the App may be incomplete, inaccurate, out of date, or may not meet your needs and requirements. Empowered Applications specifically disclaims all warranties, expressed or implied, including without limitation, the warranties or merchantability, fitness for a particular purpose and non-infringement with respect to the information, graphics and materials related to the App.<br>
        <br><br>
        <sub>4 &nbsp;&nbsp;Limitation of Liability</sub><br>
        <br>All users agree that access to and use of the App is at their own risk, and that neither Empowered Applications nor any party involved in creating or delivering the App shall, to the extent permitted by applicable law, be liable for damages of any kind, including without limitation, any special, direct or indirect, incidental, or consequential or punitive damages arising out of access to, or use of the information related to the App, or any errors or omissions, misprints, out-of-date information, technical or pricing inaccuracies, defects, delays in operational transmission, computer viruses, typographical, or other errors appearing in the App. </span></p>
        <br>
        <hr>
        <br>
        <sub>Contact DPO</sub><br>
        <br>For further information or inquiries about this Medical Disclaimer, please contact Healo&rsquo;s <em>Data Protection Officer</em>:<br><br>
        <sub><a href="mailto:core@healo.app?Subject=Attention: Healo DPO." target="_top">core@healo.app</a></sub><br><br>
        Empowered Applications AB<br>
        SE559093072201<br>
        <br>Stora gr&aring;br&ouml;dersgatan 13<br>
        222 22 Lund<br>
        Sweden<br>
        <br>
        <hr>
        <p><small><strong>Healo</strong> is a registered trademark of<br>
        Empowered Applications &copy;2017&ndash;18</small></p>
    </div>`;
export default myText;



// WEBPACK FOOTER //
// ./src/common/consents/clinical_info_en_andr.js